import clsx from 'clsx'

import { lazyload } from '@/lib/lazy-load'

const FieldConnectionStepTwo = lazyload(() =>
  import('../fields/FieldConnection').then((m) => ({ default: m.FieldConnectionStepTwo }))
)

interface ColumnSettingFieldsStepTwoProps {
  wrapClassName?: string
}

export function ColumnSettingFieldsStepTwo({ wrapClassName }: ColumnSettingFieldsStepTwoProps) {
  return (
    <div className={clsx('max-h-[65vh] overflow-y-auto mk-scroll', 'w-full py-2 px-4', wrapClassName)}>
      <FieldConnectionStepTwo />
    </div>
  )
}
